import { type UseQueryResult, useQuery } from 'react-query';
import { OptionExerciseService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetSettlementType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const settlementType = useQuery(
    ['getSettlementType'],
    async () => {
      return await handleRequest(
        OptionExerciseService.getApiAwardApiAppOptionExerciseSettlementTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
            systemName: item.systemName ?? '',
          };
        });
      },
    }
  );
  return settlementType;
};

export default useGetSettlementType;
